<template>
  <div>
    <v-card-title class="text-h5 font-weight-bold">
      {{
        selectedOrder
          ? `Pedido # ${selectedOrder.NUMEROEXPORTADO} | ${selectedOrder.TIPO} ${selectedOrder.NUMERO}/${selectedOrder.SERIE}`
          : 'Selecione um Pedido.'
      }}
    </v-card-title>
    <v-card-subtitle>
      {{
        selectedOrder
          ? ' Feito às ' +
            new Date(selectedOrder.DATA + '-03:00').toLocaleDateString(
              'pt-BR'
            ) +
            ' ' +
            selectedOrder.HORA
          : ''
      }}

      {{
        `${
          selectedOrder && selectedOrder.NOME_EMPRESA
            ? '● ' + selectedOrder.NOME_EMPRESA
            : ''
        }`
      }}
    </v-card-subtitle>
    <v-row dense>
      <template v-if="selectedOrder">
        <v-col>
          <v-card tile>
            <v-container>
              <!-- <div>
                              <v-chip small color="deep-purple darken-4">
                                <v-icon left>
                                  {{
                                    getTipoPrevisaoEntrega(
                                      selectedOrder.TIPOPREVISAOENTREGA
                                    ).icon
                                  }}
                                </v-icon>
                                {{ $t('tiposEntrega.entrega') }}
                              </v-chip>
                              {{ $t('ifood.mensagemRetira') }}
                            </div> -->
            </v-container>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-row dense>
      <v-col>
        <template v-if="selectedOrder">
          <v-card>
            <v-card-title>{{ $t('ifood.dadosPedido') }}</v-card-title>
            <v-card-text>
              <v-card
                v-for="(item, index) in selectedOrder.itens"
                :key="index"
                flat
                tile
              >
                <v-row dense>
                  <v-col cols="10">
                    <div class="d-flex text-wrap text-h6 font-weight-bold">
                      {{ formatDecimal(item.QUANTIDADE, 2) }} x
                      {{
                        item.DESCRICAO ? item.DESCRICAO : item.item.DESCRICAO
                      }}
                      {{ item.ITEM }}
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <div class="d-flex justify-end text-h6 font-weight-bold">
                      {{ formatCurrency(0, item.VALORTOTAL) }}
                    </div>
                  </v-col>
                </v-row>
                <div
                  v-if="item.observations"
                  class="d-flex text-wrap text-subtitle-1 black--text backgroundColor: grey ml-6 pa-4 rounded"
                >
                  <v-icon left color="black">mdi-pencil</v-icon>
                  {{ item.observations }}
                </div>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-card flat tile>
                <div
                  class="d-flex justify-space-between text-h6 font-weight-bold"
                >
                  <div>
                    <v-icon left>mdi-currency-usd</v-icon>
                    Desconto:
                  </div>
                  <div>
                    {{
                      formatCurrency(0, selectedOrder.ARREDONDAMENTODESCONTO)
                    }}
                  </div>
                </div>
              </v-card>
            </v-card-text>
            <v-card-text>
              <v-card flat tile>
                <div
                  class="d-flex justify-space-between text-h5 font-weight-bold"
                >
                  <div>
                    <v-icon left>mdi-currency-usd</v-icon>
                    Total Pedido
                  </div>
                  <div>
                    {{ formatCurrency(0, selectedOrder.VALOR) }}
                  </div>
                </div>
              </v-card>
            </v-card-text>
            <v-card>
              <div
                class="d-flex text-wrap text-subtitle-1 black--text backgroundColor: warning pa-4 rounded"
              >
                <v-icon left large class="mr-5">mdi-alert</v-icon>
                {{ selectedOrder.OBSERVACAO }}
              </div>
            </v-card>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
export default {
  mixins: [currencyMixin],
  props: {
    selectedOrder: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
}
</script>
